import { createContext, Dispatch, SetStateAction } from "react";
import { FieldState } from "../CustomForm/common";

export default createContext<{
  currentFieldId: string;
  setCurrentFieldId: Dispatch<SetStateAction<string>>;
  fieldStateList: FieldState[];
  setFieldStateList: Dispatch<SetStateAction<FieldState[]>>;
}>({
  currentFieldId: "",
  setCurrentFieldId: () => ({}),
  fieldStateList: [],
  setFieldStateList: () => ({}),
});
